(function () {
  var RATES = {
    vhs: { label: 'VHS', price: 25 },
    hi8: { label: 'Hi8', price: 30 },
    minidv: { label: 'MiniDV', price: 30 },
    vhsc: { label: 'VHS-C', price: 30 },
    digital8: { label: 'Digital8', price: 30 },
    betamax: { label: 'Betamax', price: 40 },
    cassette: { label: 'Audio cassette', price: 20 },
    vinyl: { label: 'Vinyl record', price: 25 },
    film8: { label: '8mm film', price: 0.3 },
    super8: { label: 'Super 8 film', price: 0.3 },
    photos: { label: 'Photos', price: 1 },
    slides: { label: 'Slides', price: 1 },
    negatives: { label: 'Negatives', price: 1 }
  };

  var GROUPS = {
    video: ['vhs', 'hi8', 'minidv', 'vhsc', 'digital8', 'betamax'],
    audio: ['cassette', 'vinyl'],
    film: ['film8', 'super8'],
    still: ['photos', 'slides', 'negatives']
  };

  var USB_PRICE = 20;
  var SHIPPING_FLAT = 15;
  var SHIPPING_FREE_AT = 100;

  var root = document.querySelector('[data-digitizing-order]');
  if (!root) return;

  var linesEl = root.querySelector('[data-lines]');
  var summaryEl = root.querySelector('[data-summary]');
  var bodyEl = root.querySelector('[data-order-body]');
  var form = root.querySelector('form');
  var deliveryError = root.querySelector('[data-delivery-error]');
  var nextId = 1;

  function money(n) {
    return '$' + n.toFixed(2);
  }

  function isPal(standard) {
    return standard === 'PAL';
  }

  function standardLabel(standard) {
    if (standard === 'unsure') return 'Not sure';
    return standard || 'NTSC';
  }

  function readLines() {
    return Array.prototype.map.call(linesEl.querySelectorAll('[data-line]'), function (line) {
      var kind = line.querySelector('[data-kind]').value;
      var format = line.querySelector('[data-format]').value;
      var qtyInput = line.querySelector('[data-qty]');
      var qty = parseInt(qtyInput.value, 10);
      var unknown = line.querySelector('[data-unknown]');
      var feet = line.querySelector('[data-feet]');
      var standard = line.querySelector('[data-standard]');
      var recording = line.querySelector('input[data-recording]:checked');
      // Film is priced by feet only — never use quantity
      if (kind === 'film') {
        qty = 0;
      } else if (isNaN(qty) || qty < 0) {
        qty = 0;
      }
      return {
        kind: kind,
        format: format,
        qty: qty,
        feet: kind === 'film' && feet ? parseInt(feet.value, 10) || 0 : 0,
        unknown: kind === 'film' && unknown ? unknown.checked : false,
        standard: standard ? standard.value : 'NTSC',
        recording: recording ? recording.value : ''
      };
    });
  }

  function readExtras() {
    var tapeReturn = root.querySelector('input[name="tape_return"]:checked');
    var digital = root.querySelector('[data-digital-access]');
    var usb = root.querySelector('[data-usb]');
    return {
      tapeReturn: tapeReturn ? tapeReturn.value : '',
      digitalAccess: digital ? digital.checked : false,
      usb: usb ? usb.checked : false
    };
  }

  function readCustomer() {
    function val(sel) {
      var el = root.querySelector(sel);
      return el ? el.value.trim() : '';
    }
    return {
      name: val('[data-field="name"]'),
      email: val('[data-field="email"]'),
      phone: val('[data-field="phone"]'),
      street: val('[data-field="street"]'),
      city: val('[data-field="city"]'),
      province: val('[data-field="province"]'),
      postal: val('[data-field="postal"]'),
      notes: val('[data-notes]')
    };
  }

  function priceLines(lines, extras) {
    extras = extras || readExtras();
    var tapeCount = 0;
    lines.forEach(function (line) {
      if ((line.kind === 'video' || line.kind === 'audio') && line.qty > 0 && RATES[line.format]) {
        tapeCount += line.qty;
      }
    });
    var perItemOff = tapeCount >= 10 ? 5 : tapeCount >= 5 ? 2 : 0;

    var stillQty = { photos: 0, slides: 0, negatives: 0 };
    lines.forEach(function (line) {
      if (line.kind === 'still' && stillQty[line.format] != null) stillQty[line.format] += line.qty;
    });

    var knownFeet = 0;
    lines.forEach(function (line) {
      if (line.kind === 'film' && !line.unknown && line.feet > 0) knownFeet += line.feet;
    });
    var filmRate = knownFeet >= 1000 ? 0.25 : 0.3;
    var filmBillable = knownFeet >= 1000 ? knownFeet : knownFeet > 0 ? Math.max(knownFeet, 200) : 0;
    var filmMinimum = knownFeet > 0 && knownFeet < 200;

    var rows = [];
    var digitizing = 0;
    var unknownFilm = false;

    lines.forEach(function (line) {
      var rate = RATES[line.format];
      if (!rate) return;
      if (line.kind === 'video' || line.kind === 'audio') {
        if (line.qty < 1) return;
        var unit = Math.max(rate.price - perItemOff, 0);
        var amount = unit * line.qty;
        var pal = line.kind === 'video' && isPal(line.standard) ? 10 * line.qty : 0;
        amount += pal;
        digitizing += amount;
        var notes = [];
        if (perItemOff) notes.push(money(perItemOff) + ' off each');
        if (pal) notes.push('PAL +' + money(10) + '/tape');
        if (line.kind === 'video' && line.standard === 'unsure') {
          notes.push('Not sure (priced as NTSC until checked)');
        }
        if (!line.recording && line.kind === 'video') notes.push('choose a recording option');
        rows.push({
          title: line.qty + ' × ' + rate.label,
          detail: notes.join(' · '),
          amount: amount
        });
      } else if (line.kind === 'still') {
        if (line.qty < 1) return;
        var discounted = stillQty[line.format] >= 100;
        var stillAmount = line.qty * (discounted ? 0.8 : 1);
        digitizing += stillAmount;
        rows.push({
          title: line.qty + ' × ' + rate.label,
          detail: discounted ? '20% off, 100 or more' : '',
          amount: stillAmount
        });
      } else if (line.kind === 'film') {
        if (line.unknown) {
          unknownFilm = true;
          rows.push({
            title: rate.label,
            detail: 'Length unknown. Measured when it arrives.',
            amount: null
          });
        } else if (line.feet > 0) {
          rows.push({
            title: rate.label + ', ' + line.feet + ' ft',
            detail: 'Included in film total below',
            amount: null
          });
        }
      }
    });

    if (filmBillable > 0) {
      var filmAmount = filmBillable * filmRate;
      digitizing += filmAmount;
      rows.push({
        title: 'Film, ' + knownFeet + ' ft known',
        detail: filmMinimum
          ? '200 ft minimum at ' + money(filmRate) + '/ft'
          : filmRate === 0.25
            ? '1,000 ft or more at $0.25/ft'
            : money(filmRate) + '/ft',
        amount: filmAmount
      });
    }

    var usbAmount = extras.usb ? USB_PRICE : 0;
    if (usbAmount) {
      rows.push({
        title: 'USB flash drive',
        detail: 'Physical delivery',
        amount: usbAmount
      });
    }

    var subtotal = digitizing + usbAmount;
    var shippingAmount = 0;
    var shipping = 'none';
    if (subtotal > 0 && subtotal < SHIPPING_FREE_AT) {
      shippingAmount = SHIPPING_FLAT;
      shipping = 'flat';
      rows.push({
        title: 'Prepaid Canadian shipping',
        detail: 'Flat-rate label for orders under $100',
        amount: shippingAmount
      });
    } else if (subtotal >= SHIPPING_FREE_AT) {
      shipping = 'free';
    }

    var total = subtotal + shippingAmount;

    return {
      rows: rows,
      digitizing: digitizing,
      usbAmount: usbAmount,
      subtotal: subtotal,
      shippingAmount: shippingAmount,
      total: total,
      perItemOff: perItemOff,
      tapeCount: tapeCount,
      unknownFilm: unknownFilm,
      shipping: shipping,
      extras: extras
    };
  }

  function renderSummary(lines) {
    var priced = priceLines(lines);
    var html = '';
    if (!priced.rows.length) {
      html = '<p class="do-summary__empty">Add a format to see your estimate.</p>';
    } else {
      html = '<ul class="do-summary__rows">';
      priced.rows.forEach(function (row) {
        html += '<li><span><strong>' + row.title + '</strong>';
        if (row.detail) html += '<small>' + row.detail + '</small>';
        html += '</span><span>' + (row.amount == null ? 'TBD' : money(row.amount)) + '</span></li>';
      });
      html += '</ul>';
    }
    html += '<p class="do-summary__total"><span>Estimate before product tax</span><strong>' + money(priced.total) + '</strong></p>';
    html += '<p class="do-summary__note">GST/HST on digitizing and USB is calculated at checkout using your shipping address. The $15 prepaid shipping charge includes its applicable tax.</p>';
    if (priced.perItemOff) {
      html +=
        '<p class="do-summary__note">Multi-tape savings of ' +
        money(priced.perItemOff) +
        ' per tape/audio item are included in this total and applied automatically at checkout.</p>';
    }
    if (priced.unknownFilm) {
      html += '<p class="do-summary__note">Film marked “I don’t know” is not included. We measure it on arrival and add it to the adjusted invoice.</p>';
    }
    if (priced.shipping === 'free') {
      html += '<p class="do-summary__note">This estimate qualifies for a free prepaid Canadian shipping label.</p>';
    } else if (priced.shipping === 'flat') {
      html += '<p class="do-summary__note">Orders under $100 include a flat-rate $15 prepaid Canadian shipping label, including shipping tax, in the total above.</p>';
    }
    if (priced.extras.tapeReturn === 'return') {
      html += '<p class="do-summary__note">Return postage for your original media is invoiced later and is not included in this total.</p>';
    } else if (priced.extras.tapeReturn === 'recycle') {
      html += '<p class="do-summary__note">Original media will be held 30 days after delivery, then securely recycled at no extra cost.</p>';
    }
    html += '<p class="do-summary__note">Time past 2 hours is $10/hr and is not in this estimate. Repair ($10), fungus cleaning ($15), and unwanted-tape handling ($5) are billed only if needed.</p>';
    summaryEl.innerHTML = html;
    return priced;
  }

  function fillBody(lines, priced) {
    var parts = ['Order items'];
    var shippingRow = null;
    priced.rows.forEach(function (row) {
      if (row.title === 'Prepaid Canadian shipping') {
        shippingRow = row;
        return;
      }
      parts.push(row.title + (row.detail ? ' (' + row.detail + ')' : '') + ': ' + (row.amount == null ? 'TBD' : money(row.amount)));
    });
    if (lines.some(function (line) { return line.kind === 'video'; })) {
      parts.push('', 'Media details');
    }
    lines.forEach(function (line) {
      if (line.kind === 'video') {
        parts.push(
          RATES[line.format].label +
            ' standard: ' +
            standardLabel(line.standard) +
            (line.standard === 'unsure' ? ' (priced as NTSC until checked)' : '')
        );
        if (line.recording) {
          parts.push(
            RATES[line.format].label +
              ' recording: ' +
              (line.recording === 'family' ? 'Stop when family content ends' : 'Record the entire tape')
          );
        }
      }
    });
    parts.push('', 'Delivery and return choices');
    if (priced.extras.tapeReturn === 'recycle') {
      parts.push('Tape return: Digitized & safely recycled (free)');
    } else if (priced.extras.tapeReturn === 'return') {
      parts.push('Tape return: Return original media (return postage invoiced later, not in this total)');
    } else {
      parts.push('Tape return: not selected');
    }
    var delivery = [];
    if (priced.extras.digitalAccess) delivery.push('Digital access (download + stream)');
    if (priced.extras.usb) delivery.push('USB flash drive (+$20)');
    parts.push('Digital delivery: ' + (delivery.length ? delivery.join('; ') : 'none selected'));
    parts.push('', 'Shipping and totals');
    if (shippingRow) {
      parts.push(shippingRow.title + (shippingRow.detail ? ' (' + shippingRow.detail + ')' : '') + ': ' + money(shippingRow.amount));
    }
    if (priced.shipping === 'free') {
      parts.push('Shipping: free prepaid Canadian label ($0)');
    } else if (priced.shipping === 'flat') {
      parts.push('Shipping: flat-rate prepaid Canadian label ' + money(priced.shippingAmount) + ' (included in estimate)');
    } else {
      parts.push('Shipping: none (no priced subtotal yet)');
    }
    parts.push('Order subtotal (before shipping and taxes): ' + money(priced.subtotal));
    parts.push('Estimated total: ' + money(priced.total));
    parts.push('Estimate before product tax (shipping tax included): ' + money(priced.total));
    if (priced.perItemOff) {
      parts.push('Multi-tape discount of $' + priced.perItemOff + ' per tape/audio already applied in cart.');
    }
    bodyEl.value = parts.join('\n');
  }

  function options(keys, selected) {
    return keys.map(function (key) {
      return '<option value="' + key + '"' + (key === selected ? ' selected' : '') + '>' + RATES[key].label + ' — ' + (GROUPS.film.indexOf(key) >= 0 ? money(RATES[key].price) + '/ft' : money(RATES[key].price)) + '</option>';
    }).join('');
  }

  function bindLine(line) {
    function paint() {
      var kind = line.querySelector('[data-kind]').value;
      var format = line.querySelector('[data-format]');
      var current = format.value;
      var keys = GROUPS[kind];
      if (keys.indexOf(current) < 0) current = keys[0];
      format.innerHTML = options(keys, current);
      line.querySelector('[data-video]').hidden = kind !== 'video';
      line.querySelector('[data-audio-note]').hidden = kind !== 'audio';
      line.querySelector('[data-film]').hidden = kind !== 'film';

      var qtyWrap = line.querySelector('[data-qty-wrap]');
      var qtyInput = line.querySelector('[data-qty]');
      if (kind === 'film') {
        qtyWrap.hidden = true;
        qtyInput.disabled = true;
        qtyInput.removeAttribute('required');
        qtyInput.value = '';
      } else {
        qtyWrap.hidden = false;
        qtyInput.disabled = false;
        if (!qtyInput.value || parseInt(qtyInput.value, 10) < 1) qtyInput.value = '1';
      }

      // Recording radios must not block submit when the video block is hidden
      Array.prototype.forEach.call(line.querySelectorAll('input[data-recording]'), function (radio) {
        if (kind === 'video') {
          radio.setAttribute('required', 'required');
        } else {
          radio.removeAttribute('required');
          radio.checked = false;
        }
      });

      var unknown = line.querySelector('[data-unknown]');
      var feetInput = line.querySelector('[data-feet]');
      if (kind === 'film') {
        feetInput.disabled = unknown.checked;
        if (!unknown.checked && (!feetInput.value || parseInt(feetInput.value, 10) < 1)) {
          feetInput.value = '50';
        }
      }
      update();
    }
    line.querySelector('[data-kind]').addEventListener('change', paint);

    line.querySelector('[data-remove]').addEventListener('click', function () {
      line.remove();
      update();
    });
    line.addEventListener('input', update);
    line.addEventListener('change', update);
    paint();
  }

  function addLine() {
    var id = nextId++;
    var line = document.createElement('fieldset');
    line.className = 'do-line';
    line.setAttribute('data-line', '');
    line.innerHTML =
      '<legend>Item</legend>' +
      '<div class="do-line__grid">' +
      '<label>Type<select data-kind><option value="video">Video tape</option><option value="audio">Audio</option><option value="film">Film</option><option value="still">Photos, slides, or negatives</option></select></label>' +
      '<label>Format<select data-format></select></label>' +
      '<label data-qty-wrap>Quantity<input data-qty type="number" min="1" value="1" inputmode="numeric"></label>' +
      '</div>' +
      '<div data-video>' +
      '<label>Video standard<select data-standard><option value="NTSC">NTSC / North America</option><option value="PAL">PAL (+$10/tape)</option><option value="unsure">Not sure</option></select></label>' +
      '<fieldset class="do-choice"><legend>When family content ends and TV or a movie starts</legend>' +
      '<label><input data-recording type="radio" name="recording-' + id + '" value="family"> Stop recording when the family content finishes</label>' +
      '<label><input data-recording type="radio" name="recording-' + id + '" value="entire"> Record the entire tape</label>' +
      '<p class="do-help">Price includes up to 2 hours. Extra time is $10/hr and is not in today’s estimate.</p></fieldset></div>' +
      '<p data-audio-note class="do-help" hidden>Price includes up to 2 hours. Extra time is $10/hr and is confirmed on an adjusted invoice.</p>' +
      '<div data-film hidden>' +
      '<label>Length (feet)<input data-feet type="number" min="1" value="50" inputmode="numeric"></label>' +
      '<label class="do-check"><input data-unknown type="checkbox"> I don’t know the length</label>' +
      '<p class="do-help">Film is priced by length only (no reel quantity). A 3-inch reel is about 50 feet. On larger reels, the length is often printed on the spool. Under 1,000 feet: $0.30/ft with a 200 ft minimum. 1,000 feet or more: $0.25/ft.</p></div>' +
      '<button type="button" data-remove>Remove</button>';
    linesEl.appendChild(line);
    bindLine(line);
  }

  function update() {
    var lines = readLines();
    var priced = renderSummary(lines);
    fillBody(lines, priced);
    Array.prototype.forEach.call(linesEl.querySelectorAll('[data-line]'), function (line, index) {
      var item = lines[index];
      var slot = line.querySelector('[data-line-price]');
      if (!slot) {
        slot = document.createElement('p');
        slot.className = 'do-line__price';
        slot.setAttribute('data-line-price', '');
        line.appendChild(slot);
      }
      slot.textContent = linePriceText(item, priced);
    });
  }

  function linePriceText(line, priced) {
    var rate = RATES[line.format];
    if (!rate) return '';
    if (line.kind === 'film') {
      if (line.unknown) return 'Measured when it arrives';
      if (line.feet < 1) return '';
      return 'Included in the film total';
    }
    if (line.qty < 1) return '';
    if (line.kind === 'still') {
      var count = 0;
      readLines().forEach(function (other) {
        if (other.kind === 'still' && other.format === line.format) count += other.qty;
      });
      var each = count >= 100 ? 0.8 : 1;
      return money(line.qty * each);
    }
    var unit = Math.max(rate.price - priced.perItemOff, 0);
    var amount = unit * line.qty;
    if (line.kind === 'video' && isPal(line.standard)) amount += 10 * line.qty;
    return money(amount);
  }

  function hasDeliveryChoice() {
    var extras = readExtras();
    return extras.digitalAccess || extras.usb;
  }

  function buildCartItems(lines, priced, variants) {
    var items = [];
    var missing = [];
    function add(id, qty, props) {
      if (qty < 1) return;
      if (!id) {
        missing.push('unavailable item');
        return;
      }
      items.push({
        id: id,
        quantity: qty,
        properties: props || {}
      });
    }
    function requireVariant(key, label) {
      if (!variants[key]) {
        missing.push(label || key);
        return null;
      }
      return variants[key];
    }

    var stillTotals = { photos: 0, slides: 0, negatives: 0 };
    lines.forEach(function (line) {
      if (line.kind === 'still' && stillTotals[line.format] != null) {
        stillTotals[line.format] += line.qty;
      }
    });

    lines.forEach(function (line) {
      var rate = RATES[line.format];
      if (!rate) return;
      if (line.kind === 'video' || line.kind === 'audio') {
        if (line.qty < 1) return;
        var variantKey = line.format;
        if (priced.perItemOff === 5 && variants[line.format + '_d5']) {
          variantKey = line.format + '_d5';
        } else if (priced.perItemOff === 2 && variants[line.format + '_d2']) {
          variantKey = line.format + '_d2';
        }
        add(requireVariant(variantKey, rate.label), line.qty, {
          Format: rate.label,
          Standard: line.kind === 'video' ? standardLabel(line.standard) : 'n/a',
          Recording: line.recording || 'n/a',
          Multi_tape_discount: priced.perItemOff
            ? money(priced.perItemOff) + ' off each'
            : 'none'
        });
        if (line.kind === 'video' && isPal(line.standard)) {
          add(requireVariant('pal', 'PAL surcharge'), line.qty, { For: rate.label });
        }
      } else if (line.kind === 'still') {
        if (line.qty < 1) return;
        var bulk = stillTotals[line.format] >= 100;
        var stillKey =
          bulk && variants[line.format + '_bulk'] ? line.format + '_bulk' : line.format;
        add(requireVariant(stillKey, rate.label), line.qty, {
          Format: rate.label,
          Bulk_discount: bulk ? '20% off (100+)' : 'none'
        });
      }
    });

    if (priced.usbAmount > 0) {
      add(requireVariant('usb', 'USB drive'), 1, {});
    }

    var knownFeet = 0;
    var filmFormats = [];
    lines.forEach(function (line) {
      if (line.kind === 'film' && !line.unknown && line.feet > 0) {
        knownFeet += line.feet;
        filmFormats.push(RATES[line.format].label + ' ' + line.feet + ' ft');
      }
    });
    if (knownFeet > 0) {
      var billable = knownFeet >= 1000 ? knownFeet : Math.max(knownFeet, 200);
      var filmKey = knownFeet >= 1000 ? 'film_ft_volume' : 'film_ft';
      add(requireVariant(filmKey, 'Film digitizing'), billable, {
        Known_feet: String(knownFeet),
        Details: filmFormats.join('; ')
      });
    }

    if (missing.length) {
      var uniq = missing.filter(function (v, i, a) {
        return a.indexOf(v) === i;
      });
      throw new Error(
        'Checkout unavailable for: ' +
          uniq.join(', ') +
          '. Please use the Contact us form at /pages/contact or try again later.'
      );
    }

    return items;
  }

  var variantsCache = null;
  function loadVariants() {
    if (variantsCache) return Promise.resolve(variantsCache);
    var url = root.getAttribute('data-variants-url');
    return fetch(url)
      .then(function (r) {
        return r.json();
      })
      .then(function (json) {
        variantsCache = json;
        return json;
      });
  }

  function showCheckoutError(msg) {
    var el = root.querySelector('[data-checkout-error]');
    if (!el) return;
    el.hidden = !msg;
    el.textContent = msg || '';
  }

  root.querySelector('[data-add]').addEventListener('click', addLine);
  form.addEventListener('change', update);
  form.addEventListener('input', update);
  form.addEventListener('submit', function (event) {
    event.preventDefault();
    showCheckoutError('');
    var lines = readLines();
    if (!lines.length) {
      showCheckoutError('Add at least one format.');
      return;
    }
    var videoMissing = lines.some(function (line) {
      return line.kind === 'video' && line.qty > 0 && !line.recording;
    });
    if (videoMissing) {
      showCheckoutError('Choose a recording option for each video tape.');
      return;
    }
    var filmMissing = lines.some(function (line) {
      return line.kind === 'film' && !line.unknown && line.feet < 1;
    });
    if (filmMissing) {
      showCheckoutError('Enter film length in feet, or check “I don’t know the length”.');
      return;
    }
    if (!hasDeliveryChoice()) {
      if (deliveryError) {
        deliveryError.hidden = false;
        deliveryError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }
    if (deliveryError) deliveryError.hidden = true;
    if (typeof root._vsValidateCustomer === 'function') {
      root._vsValidateCustomer();
    }
    if (!form.reportValidity()) return;

    var priced = priceLines(lines);
    fillBody(lines, priced);
    var customer = readCustomer();
    var submitBtn = form.querySelector('.do-submit');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Preparing checkout…';
    }

    loadVariants()
      .then(function (variants) {
        var items = buildCartItems(lines, priced, variants);
        if (!items.length) {
          throw new Error(
            'Nothing to charge yet (e.g. only unknown-length film). Add a priced format or USB, or enter film feet.'
          );
        }
        var noteParts = [
          bodyEl.value,
          '',
          'Customer contact',
          'Customer: ' + customer.name,
          'Email: ' + customer.email,
          'Phone: ' + customer.phone,
          'Address: ' +
            customer.street +
            ', ' +
            customer.city +
            ', ' +
            customer.province +
            ' ' +
            customer.postal
        ];
        if (customer.notes) noteParts.push('Notes: ' + customer.notes);
        noteParts.push('', 'Important acknowledgments');
        noteParts.push('Customer agreed that surcharges not in this estimate are billed on an additional invoice after work is done.');

        return fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' })
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: items })
            });
          })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (err) {
                throw err;
              });
            }
            return fetch('/cart/update.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                note: noteParts.join('\n'),
                attributes: {
                  order_name: customer.name,
                  order_email: customer.email,
                  order_phone: customer.phone,
                  order_address:
                    customer.street +
                    ', ' +
                    customer.city +
                    ', ' +
                    customer.province +
                    ' ' +
                    customer.postal,
                  tape_return: priced.extras.tapeReturn,
                  estimate_with_savings: String(priced.total.toFixed(2)),
                  volume_discount_each: String(priced.perItemOff || 0)
                }
              })
            });
          })
          .then(function () {
            window.location.href = '/checkout?checkout[email]=' + encodeURIComponent(customer.email);
          });
      })
      .catch(function (err) {
        var msg =
          (err && (err.description || err.message)) ||
          'Could not start checkout. Please try again or use the Contact us form at /pages/contact.';
        if (typeof msg === 'string' && /cannot find variant/i.test(msg)) {
          msg =
            'One or more digitizing products are not available on the storefront yet. Please use the Contact us form at /pages/contact so we can help complete your order.';
        }
        showCheckoutError(typeof msg === 'string' ? msg : JSON.stringify(msg));
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Continue to payment';
        }
      });
  });

  addLine();
})();
